import "./Inicio.css";
import { FaUserShield, FaHandshake, FaGavel, FaHeart, FaArrowRight, FaUsers, FaAward, FaCalendarAlt, FaCheckCircle } from "react-icons/fa";
import { useState, useEffect } from "react";

function Inicio({ onCambiarVista }) {
  const [statsVisible, setStatsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setStatsVisible(true), 500);
    return () => clearTimeout(timer);
  }, []);

  const stats = [
    { number: "500+", label: "Afiliados Activos", icon: <FaUsers /> },
    /*{ number: "1", label: "Año de Experiencia", icon: <FaAward /> },
    { number: "200+", label: "Casos Ganados", icon: <FaGavel /> },
    { number: "24/7", label: "Atención Permanente", icon: <FaCalendarAlt /> },*/
  ];

  const servicios = [
    {
      icon: <FaUserShield />,
      title: "Defensa de Derechos",
      description: "Protegemos tus derechos laborales con asesoría especializada y representación legal ante empleadores y entidades.",
      color: "blue"
    },
    {
      icon: <FaHandshake />,
      title: "Negociación Colectiva",
      description: "Negociamos acuerdos colectivos que mejoran las condiciones laborales, salarios y beneficios de todos los afiliados.",
      color: "purple"
    },
    {
      icon: <FaGavel />,
      title: "Asesoría Jurídica",
      description: "Contamos con abogados especializados en derecho laboral para acompañarte en cada proceso legal que necesites.",
      color: "pink"
    },
    {
      icon: <FaHeart />,
      title: "Bienestar Integral",
      description: "Promovemos actividades de bienestar, capacitación y desarrollo profesional para nuestros afiliados y sus familias.",
      color: "cyan"
    },
  ];

  const beneficios = [
    "Asesoría jurídica gratuita",
    "Capacitaciones y talleres",
    "Representación en negociaciones",
    "Acompañamiento en procesos legales",
    "Descuentos y convenios",
    "Red de apoyo sindical",
  ];

  return (
    <div className="inicio-container">
      {/* HERO SECTION */}
      <section className="inicio-hero">
        <div className="hero-bg-elements">
          <div className="hero-orb orb-1"></div>
          <div className="hero-orb orb-2"></div>
          <div className="hero-orb orb-3"></div>
          <div className="hero-grid"></div>
        </div>

        <div className="hero-content">
          <div className="hero-badge">
            <span className="badge-dot"></span>
            Sindicato de Trabajadores del Sector Salud
          </div>

          <h1 className="hero-title">
            Juntos somos más
            <span className="hero-title-gradient"> fuertes</span>
          </h1>

          <p className="hero-subtitle">
            En SINTRASECSALUD defendemos tus derechos laborales, negociamos mejores condiciones
            y trabajamos por el bienestar de todos los trabajadores del sector salud en Colombia.
          </p>

          <div className="hero-buttons">
            <button
              className="hero-btn primary"
              onClick={() => onCambiarVista("formulario")}
            >
              <span>¡Afíliate ahora!</span>
              <FaArrowRight className="btn-icon" />
            </button>
            <button
              className="hero-btn secondary"
              onClick={() => onCambiarVista("quienes")}
            >
              Conócenos más
            </button>
          </div>

          <div className="hero-quick-stats">
            <div className="quick-stat">
              <FaCheckCircle className="check-icon" />
              <span>100% Legal</span>
            </div>
            <div className="quick-stat">
              <FaCheckCircle className="check-icon" />
              <span>Sin cuotas ocultas</span>
            </div>
            <div className="quick-stat">
              <FaCheckCircle className="check-icon" />
              <span>Apoyo inmediato</span>
            </div>
          </div>
        </div>

        <div className="hero-visual">
          <div className="visual-card main-card">
            <div className="card-icon-big">
              <FaHandshake />
            </div>
            <h3>Unidad Sindical</h3>
            <p>La fuerza está en la unión</p>
          </div>
          <div className="floating-badge badge-1">
            <FaUserShield />
            <span>Defensa</span>
          </div>
          <div className="floating-badge badge-2">
            <FaGavel />
            <span>Justicia</span>
          </div>
          <div className="floating-badge badge-3">
            <FaHeart />
            <span>Bienestar</span>
          </div>
        </div>
      </section>

      {/* SERVICIOS */}
      <section className="inicio-servicios">
        <div className="section-header">
          <span className="section-tag">Nuestros Servicios</span>
          <h2 className="section-title">
            Trabajamos por <span className="gradient-text">tu bienestar</span>
          </h2>
          <p className="section-subtitle">
            Ofrecemos un acompañamiento integral para proteger tus derechos y mejorar tu calidad de vida laboral.
          </p>
        </div>

        <div className="servicios-grid">
          {servicios.map((servicio, index) => (
            <div key={index} className={`servicio-card ${servicio.color}`}>
              <div className="servicio-icon">
                {servicio.icon}
              </div>
              <h3>{servicio.title}</h3>
              <p>{servicio.description}</p>
              <div className="servicio-arrow">
                <FaArrowRight />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ESTADÍSTICAS */}
      <section className={`inicio-stats ${statsVisible ? 'visible' : ''}`}>
        <div className="stats-bg"></div>
        <div className="stats-content">
          <div className="section-header light">
            <span className="section-tag">Nuestro Impacto</span>
            <h2 className="section-title">
              Números que <span className="gradient-text">hablan</span>
            </h2>
          </div>

          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div key={index} className="stat-card">
                <div className="stat-icon">{stat.icon}</div>
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* BENEFICIOS */}
      <section className="inicio-beneficios">
        <div className="beneficios-content">
          <div className="beneficios-text">
            <span className="section-tag">¿Por qué afiliarte?</span>
            <h2 className="section-title">
              Beneficios de ser parte de <span className="gradient-text">SINTRASECSALUD</span>
            </h2>
            <p className="beneficios-description">
              Al unirte a nuestro sindicato, accedes a una red de apoyo que trabaja incansablemente
              por tus derechos y tu bienestar.
            </p>

            <button
              className="hero-btn primary"
              onClick={() => onCambiarVista("formulario")}
            >
              <span>Quiero afiliarme</span>
              <FaArrowRight className="btn-icon" />
            </button>
          </div>

          <div className="beneficios-list">
            {beneficios.map((beneficio, index) => (
              <div key={index} className="beneficio-item">
                <div className="beneficio-check">
                  <FaCheckCircle />
                </div>
                <span>{beneficio}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="inicio-cta">
        <div className="cta-content">
          <h2>¿Listo para hacer parte del cambio?</h2>
          <p>
            Únete a cientos de trabajadores que ya están defendiendo sus derechos
            junto a SINTRASECSALUD.
          </p>
          <div className="cta-buttons">
            <button
              className="hero-btn primary"
              onClick={() => onCambiarVista("formulario")}
            >
              <span>Afiliarme ahora</span>
              <FaArrowRight className="btn-icon" />
            </button>
            <button
              className="hero-btn secondary"
              onClick={() => onCambiarVista("contacto")}
            >
              Contáctanos
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Inicio;